/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import { createContext, type Dispatch, type SetStateAction } from 'react';
import type { CodeOutput, InstallMethod, Technology } from '../constants/installation';

export type InstallationSettings = {
	selectedTechnology: Technology;
	onSelectedTechnologyChange: Dispatch<SetStateAction<Technology>>;
	selectedInstallMethod: InstallMethod;
	onSelectedInstallMethodChange: Dispatch<SetStateAction<InstallMethod>>;
	selectedCodeOutput: CodeOutput;
	onSelectedCodeOutputChange: Dispatch<SetStateAction<CodeOutput>>;
};

export const InstallationSettingsContext = createContext<InstallationSettings>( {
	selectedTechnology: null,
	onSelectedTechnologyChange: () => {},
	selectedInstallMethod: null,
	onSelectedInstallMethodChange: () => {},
	selectedCodeOutput: null,
	onSelectedCodeOutputChange: () => {}
} );
